import { createFileRoute } from "@tanstack/react-router";
import HgBreadcrumbs from "@/common/components/ui/atoms/HgBreadcrumbs";
import AdminGuidesList from "@/features/guides/components/admin/AdminGuidesList";

export const Route = createFileRoute("/app/admin/guides/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <>
      <HgBreadcrumbs
        options={[
          { title: "Admin", link: null, unlink: true },
          { title: "Guides", link: "/app/admin/guides" },
        ]}
      />
      <h1>Guides Management</h1>
      <AdminGuidesList tableSize="medium" />
    </>
  );
}
